function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoMessages = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 179,
  height: 164,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE040",
  fillRule: "evenodd",
  d: "M56.772 150.925c31.355 0 56.773-20.633 56.773-46.086S88.127 58.754 56.772 58.754C25.418 58.754 0 79.387 0 104.839c0 11.777 5.441 22.522 14.394 30.668l-3.401 27.896 22.136-16.652c7.198 2.68 15.206 4.174 23.643 4.174",
  clipRule: "evenodd",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4690FF",
  fillRule: "evenodd",
  d: "M122.228 149.172c-31.355 0-56.773-20.634-56.773-46.086C65.455 77.633 90.873 57 122.228 57 153.582 57 179 77.633 179 103.086c0 11.776-5.441 22.521-14.394 30.668l3.401 27.896-22.136-16.653c-7.198 2.681-15.206 4.175-23.643 4.175",
  clipRule: "evenodd",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B55E",
  fillRule: "evenodd",
  d: "M88.772 12.478C57.418 12.478 32 33.111 32 58.564s25.418 46.086 56.772 46.086c31.355 0 56.773-20.634 56.773-46.086 0-11.776-5.442-22.521-14.395-30.668L134.552 0l-22.137 16.652c-7.198-2.68-15.205-4.174-23.643-4.174",
  clipRule: "evenodd",
  style: {
    mixBlendMode: "multiply"
  }
}));
export default SvgNoMessages;